// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy_ITPgh","privacyPolicyTitle":"PrivacyPolicy_privacyPolicyTitle_Ya4H7","privacyPolicyIframe":"PrivacyPolicy_privacyPolicyIframe_grQXF"};